import { render, staticRenderFns } from "./AdvertisementHooksList.vue?vue&type=template&id=05a58e2e&scoped=true"
import script from "./AdvertisementHooksList.vue?vue&type=script&lang=js"
export * from "./AdvertisementHooksList.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementHooksList.vue?vue&type=style&index=0&id=05a58e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a58e2e",
  null
  
)

export default component.exports